import { useShow } from "@refinedev/core";
import { Show, DateField, NumberField } from "@refinedev/mui";
import { Stack, Typography, Alert } from "@mui/material";

import { DetailSection, FieldGrid, FieldItem } from "components/detail";

export const PublicCenterShow = () => {
    const { queryResult } = useShow();
    const { data, isLoading, isError } = queryResult;
    const record = data?.data;

    return (
        <Show
            isLoading={isLoading}
            title={
                <Typography variant="h5">
                    공공시설 시설 상세{record?.id ? ` · ${record.id}` : ""}
                </Typography>
            }
        >
            {isError && (
                <Alert severity="error" sx={{ mb: 2 }}>
                    공공시설 시설 정보를 불러오지 못했습니다.
                </Alert>
            )}

            <Stack spacing={2}>
                <DetailSection title="기본 정보">
                    <FieldGrid columns={2}>
                        {/* 원본 NumberField(천단위 구분자) 그대로 유지 */}
                        <FieldItem
                            label="Id"
                            value={
                                record?.id != null ? (
                                    <NumberField value={record.id} />
                                ) : undefined
                            }
                        />
                        <FieldItem label="이름" value={record?.name} />
                        <FieldItem label="주소" span={2} value={record?.address} />
                        {/* 원본이 raw 값을 그대로 노출했으므로 매핑 없이 유지 */}
                        <FieldItem label="종류" value={record?.kindOf} />
                        <FieldItem label="상태" value={record?.status} />
                        {/* 원본 DateField(로케일 포맷) 그대로 유지 */}
                        <FieldItem
                            label="수정일"
                            value={
                                record?.updatedDate ? (
                                    <DateField value={record.updatedDate} />
                                ) : undefined
                            }
                        />
                    </FieldGrid>
                </DetailSection>
            </Stack>
        </Show>
    );
};
